import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import * as amchart5 from '@amcharts/amcharts5';

import './services/coralogix';
import 'overlayscrollbars/overlayscrollbars.css';
import './overlayscrollbars.css';
import './services/featureFlags';

import { App } from './App';
import { Config } from './config';

Config.amCharts.licenses.forEach((license) => {
  amchart5.addLicense(license);
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
